import React from 'react';
import { FadeIn } from './FadeIn';
export function MechanismReveal() {
  return <section className="bg-azul-noche text-white py-24 px-6 relative overflow-hidden" data-id="element-270">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-271">
        <FadeIn data-id="element-272">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center leading-tight" data-id="element-273">
            La razón real por la que tu bebé se despierta — y por qué nadie te
            la explicó antes
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-274">
          <div className="space-y-6 text-lg text-white/90" data-id="element-275">
            <FadeIn delay={0.1} data-id="element-276">
              <p data-id="element-277">
                Hay algo que pasa en el cerebro de todos los bebés del mundo,
                todas las noches, sin excepción.
              </p>
              <p className="font-bold text-2xl text-lila-suave mt-2 font-serif" data-id="element-278">
                Se llama microdespertar de transición.
              </p>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-279">
              <p data-id="element-280">
                Sucede cada 45 a 50 minutos — que es lo que dura un ciclo de
                sueño completo en un bebé de 0 a 6 meses.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-281">
              <p data-id="element-282">
                Al final de cada ciclo, el cerebro del bebé hace una pausa. Se
                asoma, por así decirlo, entre el sueño y la vigilia. En ese
                momento busca las mismas condiciones en que se quedó dormido.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-283">
              <ul className="space-y-2 pl-4 border-l-2 border-lila-suave/50" data-id="element-284">
                <li data-id="element-285">
                  Si se quedó dormido en tus brazos —{' '}
                  <span className="font-bold" data-id="element-286">busca tus brazos.</span>
                </li>
                <li data-id="element-287">
                  Si se quedó dormido en el pecho —{' '}
                  <span className="font-bold" data-id="element-288">busca el pecho.</span>
                </li>
                <li data-id="element-289">
                  Si se quedó dormido con movimiento —{' '}
                  <span className="font-bold" data-id="element-290">busca movimiento.</span>
                </li>
              </ul>
            </FadeIn>

            <FadeIn delay={0.5} data-id="element-291">
              <p data-id="element-292">
                Y si no lo encuentra — llora. No porque tenga hambre. No porque
                algo esté mal. Sino porque esa es la única herramienta que tiene
                para decirte:{' '}
                <span className="italic" data-id="element-293">"las condiciones cambiaron."</span>
              </p>
            </FadeIn>
          </div>

          <div className="flex justify-center" data-id="element-294">
            <FadeIn delay={0.3} data-id="element-295">
              <div className="bg-white/5 p-8 rounded-2xl border border-white/10 flex flex-col items-center" data-id="element-296">
                <svg width="280" height="160" viewBox="0 0 280 160" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-297">
                  {/* Base line */}
                  <line x1="20" y1="120" x2="260" y2="120" stroke="#C9B8E8" strokeWidth="2" strokeDasharray="4 4" data-id="element-298" />
                  <text x="20" y="140" fill="#C9B8E8" fontSize="12" fontFamily="sans-serif" data-id="element-299">
                    Vigilia
                  </text>

                  {/* Sleep cycle wave */}
                  <path d="M 20 120 C 50 120, 60 40, 100 40 C 140 40, 150 120, 180 120 C 210 120, 220 40, 260 40" stroke="#FFFFFF" strokeWidth="4" strokeLinecap="round" data-id="element-300" />

                  {/* Wake points */}
                  <circle cx="20" cy="120" r="6" fill="#FF8A8A" data-id="element-301" />
                  <circle cx="180" cy="120" r="8" fill="#FF8A8A" stroke="#FFFFFF" strokeWidth="2" data-id="element-302" />

                  {/* Labels */}
                  <text x="100" y="25" fill="#FFFFFF" fontSize="14" textAnchor="middle" fontFamily="sans-serif" data-id="element-303">
                    Sueño Profundo
                  </text>
                  <text x="180" y="145" fill="#FF8A8A" fontSize="14" textAnchor="middle" fontWeight="bold" fontFamily="sans-serif" data-id="element-304">
                    Microdespertar
                  </text>

                  {/* Duration */}
                  <line x1="20" y1="155" x2="180" y2="155" stroke="#FAF3E0" strokeWidth="1" data-id="element-305" />
                  <line x1="20" y1="150" x2="20" y2="160" stroke="#FAF3E0" strokeWidth="1" data-id="element-306" />
                  <line x1="180" y1="150" x2="180" y2="160" stroke="#FAF3E0" strokeWidth="1" data-id="element-307" />
                  <text x="100" y="150" fill="#FAF3E0" fontSize="12" textAnchor="middle" fontFamily="sans-serif" data-id="element-308">
                    45 minutos
                  </text>
                </svg>
                <p className="text-sm text-white/60 mt-6 text-center" data-id="element-309">
                  El ciclo de sueño natural de un bebé de 0-6 meses
                </p>
              </div>
            </FadeIn>
          </div>
        </div>

        <FadeIn delay={0.6} data-id="element-310">
          <div className="text-center mb-12" data-id="element-311">
            <h3 className="text-4xl md:text-5xl font-bold text-lila-suave font-serif mb-6" data-id="element-312">
              El Sistema de Ventanas y Señales
            </h3>
            <p className="text-xl text-white/90 max-w-2xl mx-auto" data-id="element-313">
              Requiere algo mucho más simple: enseñarle a tu bebé a terminar de
              dormirse solo — justo en el momento exacto en que su cerebro está
              listo para aprenderlo.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.7} data-id="element-314">
          <div className="bg-white text-azul-noche p-8 md:p-10 rounded-2xl shadow-2xl text-center max-w-3xl mx-auto" data-id="element-315">
            <p className="text-xl font-medium" data-id="element-316">
              Ese momento existe. Cambia semana a semana conforme el bebé crece.
              Y cuando sabes cuándo es y cómo aprovecharlo — todo cambia.
              <br data-id="element-317" />
              <br data-id="element-318" />
              Ese es el corazón de esta guía.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}